import { Dialog, DialogPanel, Transition, TransitionChild } from "@headlessui/react";
import { Fragment, useState, useEffect } from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowUpRightFromSquare, faCircleXmark, faPlusCircle } from "@fortawesome/free-solid-svg-icons";
import Button from "../../components/Button";
import { Link } from "@remix-run/react";
import { useNavigate } from "@remix-run/react";
import SavedScreeners from "../../components/offcanvas/savedScreeners";
import { FiltersOffcanvas } from "../../components/offcanvas/FiltersOffcanvas";
import ScreenerSection from "../ScreenerSection";
import mockFilterListItem from '../../filterData/screener_filters.json';
import type { FilterItem } from "../ScreenerSection";
import TextAreaFuncComp from "../TextAreaFuncComp";
import ModalTextAreaFunc from "./ModalTextAreaFunc";
import OffcanvasPanel from "../../components/OffcanvasPanel";

// ../../../components/offcanvas/OffcanvasPanel
interface ScreenerTextAreaModalProps {
    isOpen: boolean;
    onClose: (value: boolean) => void;
    displayArray: string[];
    companyScreenerApi: (queryArr: string[], limit: number, offset: number, sort_by: string, sort_direction: string) => void;
    resetCurrentPage: () => void;
    userId: string;
    isAuthenticated: boolean;
    placeholder: string;
}


export const ScreenerTextAreaModal: React.FC<ScreenerTextAreaModalProps> = ({ isOpen, onClose, displayArray, companyScreenerApi, resetCurrentPage, userId, isAuthenticated, placeholder }) => {


    return (
        <Transition show={isOpen} as={Fragment}>
            <Dialog as="div" className="relative z-50" onClose={onClose}>
                <TransitionChild
                    enter="ease-in-out duration-500"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in-out duration-500"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                >
                    <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
                </TransitionChild>

                <div className="fixed inset-0 overflow-hidden">
                    <div className="absolute inset-0 overflow-hidden">
                        <div className="pointer-events-none fixed inset-y-0 right-0 flex max-w-full">
                            <TransitionChild
                                enter="transform transition ease-in-out duration-500"
                                enterFrom="translate-x-full"
                                enterTo="translate-x-0"
                                leave="transform transition ease-in-out duration-500"
                                leaveFrom="translate-x-0"
                                leaveTo="translate-x-full"
                            >
                                <DialogPanel className="pointer-events-auto w-screen max-w-[100%] md:max-w-lg">
                                    <div className="flex h-full flex-col bg-white shadow-xl">
                                        <div className="sticky top-0 z-10 bg-white">
                                            <div className="px-4 py-5 sm:px-6">
                                                <div className="flex items-end justify-end">
                                                    <button
                                                        type="button"
                                                        className="text-gray-900 hover:text-gray-700"
                                                        onClick={() => onClose(false)}
                                                    >
                                                        <FontAwesomeIcon icon={faCircleXmark} className="h-6 w-6" aria-hidden="true" />
                                                        <span className="sr-only">Close panel</span>
                                                    </button>
                                                </div>

                                                <div className="mt-5 border-gray-200">

                                                    <ModalTextAreaFunc filterList={mockFilterListItem as FilterItem[]} isHomePage={true} handleFilterDataApi={() => { }} onScreenerQueryAppend={() => { }} isDesktop={false} isActive={true} isInputFocused={true} displayArray={displayArray} onModalClose={() => onClose(false)} companyScreenerApi={companyScreenerApi} resetCurrentPage={resetCurrentPage} userId={userId} isAuthenticated={isAuthenticated} placeholder={placeholder} />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </DialogPanel>
                            </TransitionChild>
                        </div>
                    </div>
                </div>
            </Dialog>
        </Transition>
    );
};